import { FetchError } from '../errors/FetchError'
import { } from './authorization'
import { fetchWithAuthorization, fetchImagesPrivate } from './fetch'

export const getAllPost = async ({ currentPage, perPage = 5, condominium }, complement) => {
  try {
    let url = `/post?page=${currentPage}&limit=${perPage}`
    if (condominium) {
      url += `&condominium=${condominium}`
    }
    const data = await fetchWithAuthorization(url, complement)
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error')
  }
}

export const getAllRelease = async ({ currentPage, perPage = 5, condominium }, complement) => {
  try {
    let url = `/release?page=${currentPage}&limit=${perPage}`
    if (condominium) {
      url += `&condominium=${condominium}`
    }
    const data = await fetchWithAuthorization(url, complement)
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error')
  }
}

export const getAllComment = async (params) => {
  const { id, selectedCondominium } = JSON.parse(params)
  try {
    const url = `/post/comment/${id}?condominium=${selectedCondominium}`
    const data = await fetchWithAuthorization(url)
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error')
  }
}

export const getImagePost = async (params) => {
  const { src, token } = JSON.parse(params)
  try {
    const url = `/view/image/${token}?path=${src}&size=medium`
    const data = await fetchImagesPrivate(url)
    return data
  } catch (error) {
    throw new FetchError(error, 'This is a custom error')
  }
}
